import images from "./images";

const About = {
  sub: "about us",
  heading: "Welcome to Sweet Delight's Bakery.",
  description: [
    "Where passion and creativity blend seamlessly to bring you the finest baked goods.",
    "Enjoy delightful treats that make every occasion special and every bite unforgettable. Whether you're celebrating a birthday, a wedding, or simply indulging in a sweet craving, our bakery offers a wide variety of flavors and designs to suit your taste. Every product is made with the finest ingredients and a touch of creativity, ensuring that each dessert not only tastes amazing but also creates beautiful moments to cherish."
  ],
  image: {
    src1: images.about1,
    src2: images.about2,
    src3: images.about3,
    src4: images.about4,
    alt1: "About-Image-1",
    alt2: "About-Image-2",
    alt3: "About-Image-3",
    alt4: "About-Image-4",
  },
  button: {
    text: "contact us",
    link: "Contact-us",
  },
};

export default About;

